export default "__VITE_ASSET__U2ag9PMO__"